exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Modern styling for Dialog headers and layout */\n.modern-dialog {\n  border-radius: 14px !important;\n  overflow: hidden;\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15) !important;\n}\n.modern-dialog .el-dialog__header {\n    display: none;\n    /* Custom header used instead */\n}\n.modern-dialog .el-dialog__body {\n    padding: 0 !important;\n}\n", ""]);

// exports
